/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Page_X_Of_YInputs */

const en_page_x_of_y = /** @type {(inputs: Page_X_Of_YInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Page ${i?.current} of ${i?.total}`)
};

const fr_page_x_of_y = /** @type {(inputs: Page_X_Of_YInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Page ${i?.current} de ${i?.total}`)
};

const de_page_x_of_y = /** @type {(inputs: Page_X_Of_YInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seite ${i?.current} von ${i?.total}`)
};

const it_page_x_of_y = /** @type {(inputs: Page_X_Of_YInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pagina ${i?.current} di ${i?.total}`)
};

const ru_page_x_of_y = /** @type {(inputs: Page_X_Of_YInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Страница ${i?.current} из ${i?.total}`)
};

const es_page_x_of_y = /** @type {(inputs: Page_X_Of_YInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Página ${i?.current} de ${i?.total}`)
};

const zh_cn2_page_x_of_y = /** @type {(inputs: Page_X_Of_YInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`第 ${i?.current} 页，共 ${i?.total} 页`)
};

const ja_page_x_of_y = /** @type {(inputs: Page_X_Of_YInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ページ ${i?.current} / ${i?.total}`)
};

const hi_page_x_of_y = /** @type {(inputs: Page_X_Of_YInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`पृष्ठ ${i?.current} का ${i?.total}`)
};

const pt_pt2_page_x_of_y = /** @type {(inputs: Page_X_Of_YInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Página ${i?.current} de ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Page {current} of {total}" |
*
* @param {Page_X_Of_YInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const page_x_of_y = /** @type {((inputs: Page_X_Of_YInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_X_Of_YInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_page_x_of_y(inputs)
	if (locale === "de") return de_page_x_of_y(inputs)
	if (locale === "it") return it_page_x_of_y(inputs)
	if (locale === "ru") return ru_page_x_of_y(inputs)
	if (locale === "es") return es_page_x_of_y(inputs)
	if (locale === "zh-CN") return zh_cn2_page_x_of_y(inputs)
	if (locale === "ja") return ja_page_x_of_y(inputs)
	if (locale === "hi") return hi_page_x_of_y(inputs)
	if (locale === "pt-PT") return pt_pt2_page_x_of_y(inputs)
	return en_page_x_of_y(inputs)
});